// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"828faca5","453":"88c7b3c4"}[chunkId] + ".chunk.js";
};